import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'

const VALID_FS2_LENGTHS = [1, 4]

export const isFS2SectionDataValid = (prodDetails: CustomSection): boolean => {
  const isValidVideoPresent = prodDetails.videos?.[0]?.url
  const isValidImagePresent = prodDetails.images?.[0]?.url

  const subSectionsLength = (prodDetails.subSections ?? []).length
  const areSubSectionsValidLength = VALID_FS2_LENGTHS.includes(subSectionsLength)

  const areValidIconsPresent = (prodDetails.subSections ?? []).filter(ss => ss.images?.length === 0).length === 0

  return (!!isValidVideoPresent || !!isValidImagePresent) && areSubSectionsValidLength && areValidIconsPresent
}

export const isFS2NewDesignDataValid = (section: CustomSection | undefined): boolean => {
  if (!section) {
    return false
  }

  const areSubSectionsValidLength = (section.subSections ?? []).length >= 2 && (section.subSections ?? []).length <= 4
  const areValidVisualPresent = (section.subSections ?? []).filter(ss => !ss.visual?.url).length === 0

  return areSubSectionsValidLength && areValidVisualPresent
}

export const getSectionDetailsForDevices = (
  product: Product | Bundle,
  sectionType: CUSTOM_SECTION_TYPE,
): {
  desktopSectionDetails: CustomSection | undefined
  mobileSectionDetails: CustomSection | undefined
} => {
  const desktopSectionDetails = product.desktopSections.find(ds => ds.sectionType === sectionType)
  const mobileSectionDetails = product.mobileSections.find(ds => ds.sectionType === sectionType)

  return {
    desktopSectionDetails,
    mobileSectionDetails,
  }
}
